import React from 'react';
import Scores from '../scores';
import TestDate from '../test-date';

const Act2025Form = () => (
  <>
    <TestDate />
    <Scores
      min={1}
      max={36}
      optionalFields={['act2025ScoreScience']}
      tooltips={{
        act2025ScoreScience:
          'Science is optional for this test. Please enter a score only if it was taken.',
      }}
    />
  </>
);

export default Act2025Form;
